import './shared'
import Swal from 'sweetalert2'
import '../css/sweetalert2.min.css'
import { Services } from './services.js';
import { error } from 'jquery';

try {
  // Get the URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const eligibility = urlParams.get('eligibility');

  // Initialize variables
  let jurName;
  let jurUrl;

  // Switch statement to set the values based on the eligibility parameter
  switch (eligibility) {
    case 'eligible':
      jurName = 'المشمولين في النظام الجديد';
      jurUrl = 'journey3.html';
      document.getElementById('cal-redirect').style.display = 'none';

      break;
    case 'noteligible':
      jurName = 'غير المشمولين بتعديلات الأنظمة الحالية';
      jurUrl = 'journey1.html';
      document.getElementById('cal-redirect').style.display = 'none';
      break;
    case 'graduallyeligible':
      jurName = 'المشمولين بتعديلات الأنظمة الحالية (التقاعد المدني، التأمينات الاجتماعية)';
      jurUrl = 'journey4.html';
      break;
    default:
      throw "wrong eligibility value!";
  }

  document.getElementById('eligibility-title').innerText = `أنت من ${jurName}`;
  // Set the inner text of the jur-redirect element
  document.getElementById('jur-redirect').innerHTML = `وللمزيد من التفاصيل، يمكنك الانتقال للرحلة التوعوية الخاصة ب${jurName}`;
  // Set the href attribute of the jur-herf element
  //document.getElementById('jur-herf')
  document.getElementById('jurlink').setAttribute('href', jurUrl);
} catch (error) {
  // Log the error to the console
  console.log(error);

  // Hide the eligibility element
  document.getElementById('eligibility').style.display = 'none';
}

var sweetalert2CustomClass = {
  confirmButton: 'btn', // Custom class for the confirm button
  cancelButton: 'btn'   // Custom class for the cancel button
}

const submitButton = document.getElementById('submit');
const UIDFields = document.getElementById('identifierID');
const validationMsg = document.getElementById("UIDValidationMsg");
let uuid;
const otpPhasae1Error = "";
let time = 60;
let timerInterval2;
let counter = 5;
let isSubmitNotValid = true;
//rase condetion -> check if the user entered an otp before the call has been done/ response
function timer() {
  // Countdown timer logic
  submitButton.disabled = true;
  timerInterval2 = setInterval(() => {
    if (time > 0) {
      let mins = Math.floor(time / 60);
      let secs = time % 60;
      isSubmitNotValid = false;
      validationMsg.innerText = "تم ايقاف الأرسال نظرا لتكرار ادخال الرمز" + ` ${mins}:${secs.toString().padStart(2, 0)}`;
      time--;
      console.log(4);
    } else {
      counter = 5;
      isSubmitNotValid = true;
      submitButton.disabled = false;
      clearInterval(timerInterval2);
    }
  }, 1000);
}
let timerInterval;
submitButton.addEventListener('click', () => {

  //check value & length

  time = 60;
  const regex = /^\d{10}$/;
  if (!regex.test(UIDFields.value)) {
    validationMsg.innerText = "يرجى إدخال رقم الهوية(10 أرقام)";
  } else if (counter <= 0) {
    if (isSubmitNotValid) {
      timer();
    }
  } else {
    counter--;
    validationMsg.innerText = "";
    clearInterval(timerInterval2);
    sweetalert();
  }
  console.log(isSubmitNotValid && counter <= 0);

});
let timeLeft = 60;
function timerReset() {
  clearInterval(timerInterval);
  document.getElementById('resendButton').textContent = 'إعادة الإرسال';
  // Countdown timer logic
  timerInterval = setInterval(() => {
    if (timeLeft > 0) {
      let mins = Math.floor(timeLeft / 60);
      let secs = timeLeft % 60;
      document.getElementById('resendButton').disabled = true;
      if (mins === undefined || secs === undefined) {
        document.getElementById('resendButton').textContent = 'إعادة الإرسال';
      } else {
        document.getElementById('resendButton').textContent = 'إعادة الإرسال' + ` ${mins}:${secs.toString().padStart(2, 0)}`;
      }

      timeLeft--;
    } else {
      clearInterval(timerInterval);
      document.getElementById('resendButton').textContent = 'إعادة الإرسال';
      document.getElementById('resendButton').disabled = false;
    }
  }, 1000);
}
async function sweetalert() {

  // Create a resend button
  const resendButton = document.createElement('button');
  const resendButtonText = 'إعادة الإرسال';
  resendButton.textContent = resendButtonText;
  resendButton.className = 'swal2-confirm swal2-styled btn';
  resendButton.style.display = 'block'; // Initially shown
  resendButton.disabled = true; // Initially disabled
  resendButton.id = 'resendButton';
  let isTimerStopped = false;


  let confirmErrorValidation = true; //disabled
  let inputFilled = true; //disabled

  let eligibility = "Eligible";
  let eligibilityTitle = "title";

  Swal.fire({
    html: `
        <div class="swal2-icon swal2-success swal2-icon-show">
        <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 128 160" x="0px" y="0px" class="otpIcon"><path d="M81,6V5.94043A5.94738,5.94738,0,0,0,75.05957,0H16.94043A5.94738,5.94738,0,0,0,11,5.94043V122.05957A5.94738,5.94738,0,0,0,16.94043,128H75.05957A5.94738,5.94738,0,0,0,81,122.05957V60.28333L77,62.413v59.64655A1.94217,1.94217,0,0,1,75.05957,124H16.94043A1.94217,1.94217,0,0,1,15,122.05957V5.94043A1.94217,1.94217,0,0,1,16.94043,4H75.05957A1.94217,1.94217,0,0,1,77,5.94043V6Z"/><circle cx="22" cy="11" r="3"/><path d="M42,118a2,2,0,0,0,0,4h8a2,2,0,0,0,0-4Z"/><path d="M69,78.416V53.584A3.5876,3.5876,0,0,0,65.416,50H26.584A3.5876,3.5876,0,0,0,23,53.584V78.416a3.557,3.557,0,0,0,.65527,2.054,1.9846,1.9846,0,0,0,.30957.38055l.01239.00952A3.56473,3.56473,0,0,0,26.584,82H65.416A3.5876,3.5876,0,0,0,69,78.416ZM57.433,66.77386l-3.26807,2.36L62.45007,78H29.36865L37.769,69.01544l-3.24274-2.38922L27,74.6759V56.11316L43.666,68.3916a3.76456,3.76456,0,0,0,4.66211.02344L65,56.37512v18.4964ZM30.87628,54H61.45734L46.01367,65.15234Z"/><path d="M95.17383,48.23242h16.47852A6.32067,6.32067,0,0,0,118,41.95313V16.2793A6.32067,6.32067,0,0,0,111.65234,10H70.34766A6.32067,6.32067,0,0,0,64,16.2793V41.95313a6.32067,6.32067,0,0,0,6.34766,6.2793h5.30078l-4.876,8.79785a1.99992,1.99992,0,0,0,2.68848,2.73535L95.07617,48.25684A.21581.21581,0,0,1,95.17383,48.23242Zm-1.97461-3.50781-15.65234,8.334L80.793,47.20215a1.99975,1.99975,0,0,0-1.749-2.96973H70.34766A2.31657,2.31657,0,0,1,68,41.95313V16.2793A2.31657,2.31657,0,0,1,70.34766,14h41.30469A2.31657,2.31657,0,0,1,114,16.2793V41.95313a2.31657,2.31657,0,0,1-2.34766,2.2793H95.17383a4.22532,4.22532,0,0,0-1.97266.49121Z"/><path d="M82.68945,26.39258a2.00278,2.00278,0,0,0-2.76074-.61816L79,26.36322v-.54974a2,2,0,1,0-4,0v.54974l-.92871-.58881a2.00048,2.00048,0,0,0-2.14258,3.37891L73.2641,30l-1.33539.84668a2.00048,2.00048,0,0,0,2.14258,3.37891L75,33.63678v.54974a2,2,0,0,0,4,0v-.54974l.92871.58881a2.00048,2.00048,0,1,0,2.14258-3.37891L80.7359,30l1.33539-.84668A2.00153,2.00153,0,0,0,82.68945,26.39258Z"/><path d="M96.68945,33.60742a2.00153,2.00153,0,0,0-.61816-2.76074L94.7359,30l1.33539-.84668a2.00048,2.00048,0,1,0-2.14258-3.37891L93,26.36322v-.54974a2,2,0,1,0-4,0v.54974l-.92871-.58881a2.00048,2.00048,0,0,0-2.14258,3.37891L87.2641,30l-1.33539.84668a2.00048,2.00048,0,0,0,2.14258,3.37891L89,33.63678v.54974a2,2,0,0,0,4,0v-.54974l.92871.58881a2.00174,2.00174,0,0,0,2.76074-.61816Z"/><path d="M99.31055,33.60742a2.00174,2.00174,0,0,0,2.76074.61816L103,33.63678v.54974a2,2,0,0,0,4,0v-.54974l.92871.58881a2.00048,2.00048,0,0,0,2.14258-3.37891L108.7359,30l1.33539-.84668a2.00048,2.00048,0,0,0-2.14258-3.37891L107,26.36322v-.54974a2,2,0,1,0-4,0v.54974l-.92871-.58881a2.00048,2.00048,0,0,0-2.14258,3.37891L101.2641,30l-1.33539.84668A2.00153,2.00153,0,0,0,99.31055,33.60742Z"/></svg>
        </div>
        <div class="mb-3 mt-3">الرجاء إدخال الرمز المرسل إلى هاتفك الجوال</div>
          <div class="otpContainer">
            <div class="input-field"><input id="swal-input1" class="swal2-input customFocus" autocomplete="one-time-code" maxlength="1" inputmode="numeric" autofocus></div>
            <div class="input-field"><input id="swal-input2" class="swal2-input customFocus" autocomplete="one-time-code" maxlength="1" inputmode="numeric"></div>
            <div class="input-field"><input id="swal-input3" class="swal2-input customFocus" autocomplete="one-time-code" maxlength="1" inputmode="numeric"></div>
            <div class="input-field"><input id="swal-input4" class="swal2-input customFocus" autocomplete="one-time-code" maxlength="1" inputmode="numeric"></div>
          </div>
        `,
    confirmButtonText: `متابعة`,
    cancelButtonText: `إلغاء`,
    showCancelButton: true,
    customClass: sweetalert2CustomClass,
    preConfirm: async () => {
      let validConfirm = false;
      const input1 = document.getElementById('swal-input1').value;
      const input2 = document.getElementById('swal-input2').value;
      const input3 = document.getElementById('swal-input3').value;
      const input4 = document.getElementById('swal-input4').value;

      let otp;
      if (![input1, input2, input3, input4]) {
        Swal.showValidationMessage("الرجاء إدخال الرمز المرسل إلى هاتفك الجوال");
      } else {
        otp = `${input1}${input2}${input3}${input4}`;



        try {
          const response = await Services.submitOTP(UIDFields.value, uuid, otp);
          const jsonResponse = await response.json();
          confirmErrorValidation = true;
          // if (jsonResponse.message.english === "Please enter OTP" && jsonResponse.uuid) {
          if (jsonResponse.pensionReformEligible) {
            console.log('work1');
            validConfirm = true;
            eligibility = jsonResponse.pensionReformEligible;
            eligibilityTitle = jsonResponse.message.arabic;
            clearInterval(timerInterval);
            Swal.getConfirmButton().disabled = true;
            Swal.getCancelButton().disabled = true;
          } else {
            Swal.showValidationMessage(jsonResponse.message.arabic);

          }
        } catch (e) {
          Swal.showValidationMessage("هناك مشكلة مؤقتة يرجى المحاولة في وقت لاحق");
          timeLeft = 60;
        }
        Swal.hideLoading();
        Swal.getConfirmButton().disabled = confirmErrorValidation || inputFilled;
        document.getElementById('swal-input1').focus();

      }

      // Reset input fields (optional)
      document.getElementById('swal-input1').value = '';
      document.getElementById('swal-input2').value = '';
      document.getElementById('swal-input3').value = '';
      document.getElementById('swal-input4').value = '';


      // Hide resend button and focus on the first input
      document.getElementById('swal-input1').focus();

      return validConfirm;
    },
    didOpen: async () => {
      clearInterval(timerInterval);
      // Append the resend button to the Swal footer
      const swalFooter = Swal.getFooter();
      if (swalFooter) {
        swalFooter.appendChild(resendButton);
        swalFooter.classList.add('d-flex');
        swalFooter.classList.add('justify-content-center');
        document.getElementById('resendButton').disabled = true;
      }

      const inputs = [
        document.getElementById('swal-input1'),
        document.getElementById('swal-input2'),
        document.getElementById('swal-input3'),
        document.getElementById('swal-input4')
      ];

      document.getElementById('swal-input1').focus();

      inputs.forEach((input, idx) => {
        // Handle paste event
        input.addEventListener('paste', (e) => {
          let paste = (e.clipboardData || window.clipboardData).getData('text');
          paste = paste.replace(/[^0-9]/g, '').substr(0, 4); // Get only first 4 digits

          // Distribute the pasted content to the inputs
          paste.split('').forEach((char, i) => {
            if (inputs[i]) {
              inputs[i].value = char;
              inputs[i].dispatchEvent(new Event('input')); // Trigger the input event
            }
          });

          e.preventDefault(); // Prevent the default paste action
        });

        // Handle input event
        input.addEventListener('input', (e) => {
          e.target.value = e.target.value.replace(/[^0-9]/g, '').substr(0, 1);

          // Check if all inputs are filled
          const allFilled = inputs.every(inp => inp.value);
          inputFilled = !allFilled
          // Enable or disable the Continue button based on inputs
          Swal.getConfirmButton().disabled = inputFilled || confirmErrorValidation;

          // Move to next input if a number is entered and not the last input
          if (e.target.value && idx < inputs.length - 1) {
            inputs[idx + 1].focus();
          }
        });
      });
      document.getElementById('swal-input1').focus();
      Swal.getConfirmButton().disabled = confirmErrorValidation;
      Swal.showLoading();

      document.getElementById('swal-input1').focus();

      // Focusing to the inputs if backspace event triggers
      const inputs1 = document.querySelectorAll('.swal2-input');
      inputs1.forEach((input, index) => {
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Backspace' && input.value === '') {
            const previousInput = inputs1[index - 1];
            if (previousInput) {
              previousInput.focus();
            }
          }
        });
      });



      try {
        const response = await Services.requestOTP(UIDFields.value);
        const jsonResponse = await response.json();
        confirmErrorValidation = true;
        console.log(jsonResponse);
        if (jsonResponse.message.english === "Please enter OTP" && jsonResponse.uuid) {
          console.log('work2');
          uuid = jsonResponse.uuid;
          confirmErrorValidation = false;
          timeLeft = 60;
        } else {
          Swal.showValidationMessage(jsonResponse.message.arabic);
          if (jsonResponse.message.english === "You have exceeded the allowed number of attempts. Please try  again after 5 minutes.") {
            timeLeft = 300; // 5 mins
          } else {
            timeLeft = 60; // 5 mins
          }
        }
      } catch (e) {
        Swal.showValidationMessage("هناك مشكلة مؤقتة يرجى المحاولة في وقت لاحق");
        timeLeft = 60;
      }
      Swal.hideLoading();
      Swal.getConfirmButton().disabled = confirmErrorValidation || inputFilled;
      document.getElementById('swal-input1').focus();






      timerReset();
      document.getElementById('swal-input1').focus();

      // Add click event to resend button
      document.getElementById('resendButton').addEventListener('click', async () => {


        document.getElementById('swal-input1').focus();
        Swal.resetValidationMessage();
        // Hide resend button
        document.getElementById('resendButton').disabled = true;
        document.getElementById('swal-input1').focus();
        // Show loading and a new message



        // Reset input fields (optional)
        document.getElementById('swal-input1').value = '';
        document.getElementById('swal-input2').value = '';
        document.getElementById('swal-input3').value = '';
        document.getElementById('swal-input4').value = '';


        Swal.showLoading();
        // Hide resend button and focus on the first input
        document.getElementById('swal-input1').focus();



        try {
          response = await Services.requestOTP(UIDFields.value);
          jsonResponse = await response.json();
          confirmErrorValidation = true;
          console.log(jsonResponse);
          if (jsonResponse.message.english === "Please enter OTP" && jsonResponse.uuid) {
            console.log('work3');
            const swalTitle = Swal.getTitle();
            if (swalTitle) {
              swalTitle.textContent = 'أدخل الرمز الجديد';
            }
            timeLeft = 60;
          } else {
            Swal.showValidationMessage(jsonResponse.message.arabic);
            if (jsonResponse.message.english === "You have exceeded the allowed number of attempts. Please try  again after 5 minutes.") {
              timeLeft = 300; // 5 mins
            } else {
              timeLeft = 60; // 5 mins
            }
          }
        } catch (e) {
          Swal.showValidationMessage("هناك مشكلة مؤقتة يرجى المحاولة في وقت لاحق");
          timeLeft = 60;

        } finally {
          Swal.hideLoading();
        }

        Swal.hideLoading();
        Swal.getConfirmButton().disabled = confirmErrorValidation || inputFilled;
        document.getElementById('swal-input1').focus()

        timerReset();
      });


    },

  }).then((result) => {
    clearInterval(timerInterval);
    if (result.isConfirmed) {
      let journeyURL = 'journey3.html';
      let journeyTitle = eligibilityTitle;
      switch (eligibility) {
        case "Not Eligible":
          journeyURL = 'journey1.html';
          journeyTitle += " ونظام التأمينات الاجتماعية الجديد";
          break;
        case "Eligible":
          journeyURL = 'journey3.html';
          break;
        case "Impacted":
          journeyURL = 'journey4.html';
          break;
      };

      Swal.fire({
        icon: "success",
        title: journeyTitle,
        showConfirmButton: true,
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonText: 'متابعة لرحلتك الخاصة',
        cancelButtonText: 'إلغاء',
        customClass: sweetalert2CustomClass,
      }).then((result) => {
        if (result.isConfirmed) {
          // User clicked on 'متابعة لرحلتك الخاصة', navigate to the URL
          window.location.href = journeyURL;
        }
      });
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      console.log('Cancelled!');
    } else if (result.dismiss === Swal.DismissReason.backdrop ||
      result.dismiss === Swal.DismissReason.esc ||
      result.dismiss === Swal.DismissReason.close) {

      console.log('Alert dismissed by: ' + result.dismiss);
    }
  });

}
